import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Flex, Typography } from 'antd';

import { t } from '../../utils/i18n';
import { useGlobals } from '../../globals-context';
import { changeLocation } from '../../actions';
import EVENT_BUS_EVENTS from '../../constants/event-bus-events';

export function UserActionNotifications() {
  const dispatch = useDispatch();
  const { eventBus, trackMethod } = useGlobals() as any;
  const actionPanel = useSelector((state: any) => state.actionPanel);
  const currentMerchant = useSelector((state: any) => state.currentMerchant);

  const trialDaysLeft = currentMerchant?.trialDaysLeft || 0;
  const showPaymentWarning = actionPanel?.showPaymentWarning || false;

  const handleOnUpgradeNowButtonClick = () => {
    const route = '/settings/subscription';
    trackMethod('action_notification_button_clicked', {
      platform: 'booking',
      location: 'top_notifications_buttons',
      menu_item: 'upgrade_now',
    });
    dispatch(changeLocation(route));
    eventBus?.emit(EVENT_BUS_EVENTS.NAVIGATE, { payload: { route } });
  };

  const handleOnCheckPaymentsButtonClick = () => {
    const route = '/application-settings/payments';
    trackMethod('action_notification_button_clicked', {
      platform: 'booking',
      location: 'top_notifications_buttons',
      menu_item: 'check_payments',
    });
    dispatch(changeLocation(route));
    eventBus?.emit(EVENT_BUS_EVENTS.NAVIGATE, { payload: { route } });
  };

  return (
    <>
      {Boolean(trialDaysLeft) && (
        <Alert
          banner
          closable
          type="info"
          showIcon={false}
          message={
            <Flex gap={16} justify="center" align="center">
              <Typography.Text>
                {t('trial-days.message', {
                  days: trialDaysLeft,
                })}
              </Typography.Text>
              <Button
                danger
                size="small"
                color="primary"
                variant="solid"
                onClick={handleOnUpgradeNowButtonClick}
              >
                {t('trial-days.cta-button')}
              </Button>
            </Flex>
          }
        />
      )}

      {Boolean(showPaymentWarning) && (
        <Alert
          banner
          closable
          type="warning"
          showIcon={false}
          message={
            <Flex gap={16} justify="center" align="center">
              <Typography.Text>
                {t('payment-warning.message-text')}
              </Typography.Text>
              <Button
                size="small"
                color="orange"
                variant="solid"
                onClick={handleOnCheckPaymentsButtonClick}
              >
                {t('payment-warning.cta-button')}
              </Button>
            </Flex>
          }
        />
      )}
    </>
  );
}
